<template>
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     @review="handleReview"
                     :btn_add="canAdd"
                     btn_review
        >

            <div class="pull-right">
                <calendar-picker-filter :value="search.date_range" @change="handleCalendarChange" ></calendar-picker-filter>
                <el-button class="ml-2 mt-1" type="success" size="small" @click="downloadReport" icon="el-icon-download">下载列表</el-button>
                <el-badge v-if="incomplete" :value="incomplete" style="margin-top: -3px;" class="ml-2" >
                    <el-button type="warning" size="small" @click="$router.push('/questionnaire')">问卷</el-button>
                </el-badge>
            </div>
        </front-table>
        <!--编辑界面-->

        <meeting-view :view_mode="view_mode" :single="single" @start="startMeeting" @mail="mailAttendees"
                      @cancel="view_mode = false">
        </meeting-view>

        <div v-show="show_table" ref="excel_table">
            <el-table border size="small"
                      :data="table.data" show-summary
                      style="width: 100%">
                <el-table-column v-for="header in table.headers" :key="header.prop"
                                 :prop="header.prop"
                                 :label="header.label">
                </el-table-column>
            </el-table>
        </div>

    </section>
</template>

<script>
import MyMeetingMixin from "@/views/mixins/my-meeting"
import "@/views/scss/my-meeting.scss"
import FrontTable from "@/components/front-table";
import MeetingView from "@/components/meeting-view";
import CalendarPickerFilter from "@/components/calendar-picker-filter";

export default {
    name: 'my-meeting',
    mixins: [MyMeetingMixin],
    components: {MeetingView, FrontTable,CalendarPickerFilter},
}
</script>

